import React, { useEffect, useRef, useState } from 'react'
import { AdminCloseIcon, BrandingEmoji } from '../../../utils/icons';
import { containsDefaultPng, fetchApi, getInitials } from '../../../utils/methods';
import { ImageUrl } from '../../../utils/constants';
import { StyledModal, StyledBody, TopSectionV2, PostButton, PostButtonFeed, PostPopupTop} from '../../PhotoAndPostFlow/styles';
import { t } from 'i18next';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import { InputTextAreaNew, UserInitialsMain } from '../../SocialFeedsV2/styles';
import SocialFeedsEmojiPicker from '../../SocialFeedsEmojiPicker';
import { toast } from 'react-toastify';
import { EditEventMoment } from '../../../redux/constants/apiConstants';
import Spinner from '../../common/Spinner';

const EditMoment = ({onClose,showModal, user,profileImage,moment,getSharedMoments,companyId,/*getEventDetailsById*/event}) => {
  const inputRef = useRef();
  const[desc, setDesc]= useState(moment?.text);
  const[displayEmoji, setDisplayEmoji] = useState(false);
  const [position, setPosition] = useState({ start: 0, end: 0 });
  const[loading, setLoading]=useState(false);

  useEffect(()=>{

  },[])


  const editMoment = async()=>{
    setLoading(true);
    const payload = {text:desc};
    try{
      const res = await fetchApi(EditEventMoment + '/' +  moment.id, "PUT",payload);
      if(res.status === "success"){
        // setWellnessChallengeList(res.data);
        // getEventDetailsById(moment.id)
        toast.success(res?.message);
        setLoading(false);
        onClose()
        getSharedMoments(companyId,1)
        
      }else{
        toast.error(res.message);
        setLoading(false);
      }
    }catch(error){
      toast.error(error);
      setLoading(false);
    }

  }

  const removeBoldTag=(input)=> {
    const regex = input.replace(/<b>/, "").replace(/<\/b>/, "").replace(/>/gi, "").replace(/<b/gi, "")
    return(regex)
  }

  const onEmojiSelect = (emoji, id, native, skin) => {
    window.console.log("hii",emoji, id,skin)
    addInspirationV2(native);
  };

  const getPosition = (el) => {
    let start = 0,
      end = 0,
      normalizedValue,
      range,
      textInputRange,
      len,
      endRange;

    if (
      typeof el.selectionStart == "number" &&
      typeof el.selectionEnd == "number"
    ) {
      start = el.selectionStart;
      end = el.selectionEnd;
    } else {
      range = document.selection.createRange();

      if (range && range.parentElement() == el) {
        len = el.value.length;
        normalizedValue = el.value.replace(/\r\n/g, "\n");
        textInputRange = el.createTextRange();
        textInputRange.moveToBookmark(range.getBookmark());
        endRange = el.createTextRange();
        endRange.collapse(false);

        if (textInputRange.compareEndPoints("StartToEnd", endRange) > -1) {
          start = end = len;
        } else {
          start = -textInputRange.moveStart("character", -len);
          start += normalizedValue.slice(0, start).split("\n").length - 1;

          if (textInputRange.compareEndPoints("EndToEnd", endRange) > -1) {
            end = len;
          } else {
            end = -textInputRange.moveEnd("character", -len);
            end += normalizedValue.slice(0, end).split("\n").length - 1;
          }
        }
      }
    }

    return {
      start: start,
      end: end,
    };
  };

  const addInspirationV2 = (e) => {
    // Create the new description with the added text
    const newText =
      desc.slice(0, position.start) +
      e +
      desc.slice(position.end);

    // Update the position and desc state
    setPosition((prevPosition) => ({
      start: prevPosition.start + e.length,
      end: prevPosition.end + e.length,
    }));
    setDesc(newText);
  };

  


  const textArea = ()=>(
    <>
      <InputTextAreaNew
      //   onKeyDown={this.handleKey}
      //   isCommentOrReply={isCommentOrReply}
      //   padding={placeholder.includes('reply') ? '13px' : '0'}
      //   width={placeholder.includes('reply') ? '80%' : '100%'}
      >
        <textarea
        //   style={{  minHeight: '200px' }}
          placeholder={'Write your thoughts and upload images here'}
          rows="1" // Start with a single row
          name=""
          onChange={(e) => {
            setDesc(e.target.value);
            const position = getPosition(e.target);
            setPosition(position);
            //   this.props.addInspiration(e);
            // Adjust the height based on content
            e.target.style.height = 'auto'; // Reset height
            e.target.style.height = `${e.target.scrollHeight}px`; // Set height to scrollHeight
          }}
          //   onClick={(e) => this.props.addInspiration(e)}
          value={removeBoldTag(desc)}
          data-gramm_editor="false"
          className={'CustomTextAreaField'}
          //   onScroll={onScroll}
          spellCheck="false"
          ref={inputRef}
          id="inpu"
          maxLength={'300'}
        >
          {desc}
        </textarea>
      </InputTextAreaNew>
      {displayEmoji ? <SocialFeedsEmojiPicker selectEmoji={onEmojiSelect} emojiRef={inputRef} hidePicker={()=>setDisplayEmoji(false)}></SocialFeedsEmojiPicker> : null}
    </>
  )
    
  return (
    <>
      <StyledModal show={showModal} onHide={()=>{onClose();}} width="800px">
        <PostPopupTop>
          <div className='heading'>{t("Edit Your Moment")}</div>
          <div className='closeIcon' onClick={()=>{onClose();}}>{AdminCloseIcon()}</div>
        </PostPopupTop>
        <div style={{height:"1px", width:"100%", background:"#EFEFEF", margin:"0"}}/>
        <StyledBody>
          <TopSectionV2 
            //   disable={} 
            background maxHeight="320px" margin="16px 0">
            <div className='user-details'>
              <div className='profile'>
                {!containsDefaultPng(profileImage)?
                  <img src={ImageUrl + "/" +profileImage}/>:
                  <UserInitialsMain font>{`${getInitials(user?.fname)}${getInitials(user?.lname)}`}</UserInitialsMain>}
              </div>
              <div className='privacy-admin' style={{flexDirection:'column',alignItems:'start'}}>
                <div className='name'>{user.fname} {user.lname}</div>
                <div className="timeLoactionContainer">
                  <div className='location'>{event?.title}</div>
                </div>
              </div>
            </div>
            {textArea()}

            <PostButton>
              <div className='btn-container'>
                <div className='emojiIcon' 
                  onClick={()=>setDisplayEmoji(true)}
                >     
                  {BrandingEmoji()}
                </div>
              </div>
              <div className='char-count'>
                {desc.length}/300 | C
              </div>
            </PostButton>
            
            <PostButtonFeed disable={  !desc || loading } margin={'16px 0px'}>
              <div className='button' 
                onClick ={()=> desc && !loading && editMoment()}
              >
                {loading ? <Spinner color={"#F37A65"}/> : 'Save'}
                <span/>
                {/* {!loading && PostButtonIcon(!user || !desc || loading   ? "#BDBDBD":"#F8F8F8")} */}
              </div>
            </PostButtonFeed>
          </TopSectionV2>
        </StyledBody>
      </StyledModal>

    </>
  )
}

EditMoment.propTypes = {
  onClose: PropTypes.func,
  showModal:PropTypes.bool,
  user:PropTypes.object,
  profileImage:PropTypes.string,
  moment:PropTypes.object,
  getSharedMoments:PropTypes.func,
  companyId:PropTypes.string,
  page:PropTypes.number,
  getEventDetailsById:PropTypes.func,
  event:PropTypes.object
}

const mapStateToProps = (state) => ({
  user: state.profileData.user,
  profileImage: state.profileData.profileImage,
});

export default connect(mapStateToProps, null)(withTranslation()(EditMoment));